import { dowloadWithToken, DOWNLOAD_FASTTAG_DETAILS_URL } from 'Utils/api';
import { TOAST_ERROR, TOAST_SUCCESS } from 'Constants/actionConstants';
import { store } from '../../../../index';

/**
 * Ported from the old tracking screen's GET_FAST_TAG_LOGS saga - it's a pure
 * file download (dowloadWithToken saves the .xls blob itself), there's no
 * results panel to render.
 */
export const downloadFastTagLogs = (tripId) => {
  dowloadWithToken(DOWNLOAD_FASTTAG_DETAILS_URL, `fastTag${tripId}.xls`, { trip_id: tripId })
    .then(() => store.dispatch({ type: TOAST_SUCCESS, message: 'Downloading FastTag Logs...' }))
    .catch((error) => {
      console.log('[TripTrackingV2] fastag logs download error:', error);
      store.dispatch({ type: TOAST_ERROR, message: (error && error.message) || 'Oops! Something went wrong' });
    });
};
